import slice from "./driversSlice";

export default slice.reducer;
